import { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import type { AcompanhamentoDto } from '@nexital/shared';
import { Avatar } from '../design-system/Avatar';
import { Dialogo } from '../design-system/Dialogo';
import { useNotas } from './contexto-notas';

type Pessoas = AcompanhamentoDto['pessoas'];

function DialogoAcompanhamento({ pessoas, fechar }: { pessoas: Pessoas; fechar: () => void }) {
  const definir = useNotas((s) => s.definirAcompanhamento);
  const [marcadas, setMarcadas] = useState(() => new Set(pessoas.filter((p) => p.acompanhando).map((p) => p.uuid)));
  const alternar = (uuid: string) =>
    setMarcadas((atual) => {
      const nova = new Set(atual);
      if (!nova.delete(uuid)) nova.add(uuid);
      return nova;
    });
  const salvar = async () => {
    if (await definir([...marcadas])) fechar();
  };
  return (
    <Dialogo
      titulo="Notas da equipe"
      descricao="Marque de quem você quer ver as notas privadas neste quadro. Elas aparecem só para leitura, com o nome do autor."
      rotuloConfirmar="Salvar"
      aoConfirmar={() => void salvar()}
      aoCancelar={fechar}
    >
      {pessoas.length ? (
        <ul className="compartilhar__lista">
          {pessoas.map((p) => (
            <li key={p.uuid}>
              <label className="compartilhar__pessoa">
                <input type="checkbox" checked={marcadas.has(p.uuid)} onChange={() => alternar(p.uuid)} />
                <Avatar nome={p.nome} chave={p.uuid} tamanho={22} />
                {p.nome}
                <span className="acompanhamento__perfil">{p.perfil}</span>
              </label>
            </li>
          ))}
        </ul>
      ) : (
        <p className="modulo__vazio">Não há pessoas que você possa acompanhar neste quadro.</p>
      )}
    </Dialogo>
  );
}

/**
 * Gestor e administrador ativam as notas privadas de quem acompanham (o administrador, de todos; o gestor, de
 * colaboradores e leitores). Para os demais perfis o botão não aparece.
 */
export function Acompanhamento() {
  const obter = useNotas((s) => s.obterAcompanhamento);
  const [pessoas, setPessoas] = useState<Pessoas | null>(null);
  const [aberto, setAberto] = useState(false);
  const acompanhando = pessoas?.filter((p) => p.acompanhando).length ?? 0;

  useEffect(() => {
    void obter().then((dto) => setPessoas(dto?.pessoas ?? null));
  }, [obter, aberto]);

  if (!pessoas) return null;
  return (
    <>
      <button type="button" className="acompanhamento__botao" onClick={() => setAberto(true)} aria-haspopup="dialog">
        <Eye size={16} aria-hidden /> Notas da equipe{acompanhando > 0 && <span className="acompanhamento__contador">{acompanhando}</span>}
      </button>
      {aberto && <DialogoAcompanhamento pessoas={pessoas} fechar={() => setAberto(false)} />}
    </>
  );
}
